import { createSelector } from '@reduxjs/toolkit';
import type { DbProtocolManifest } from '@hub/common';
import type { RootState } from 'features/store/store';

export const selectOptionalParticipationDocData = (state: RootState) =>
  state.participation.docData;

export const selectParticipationDocumentNotFound = (state: RootState) =>
  state.participation.documentNotFound;

export const selectParticipationDocData = (state: RootState) => {
  const value = state.participation.docData;
  if (!value) {
    throw new Error(
      '[ASSERT FAILED, REDUX SELECTOR] Attempt to rely on participation.docData while it is not available in store'
    );
  }
  return value;
};

export const selectParticipationTranslationManifests = createSelector(
  [selectOptionalParticipationDocData],
  (participation): Record<string, DbProtocolManifest> =>
    participation ? { [participation.assetId]: participation.manifest } : {}
);
